<script lang="ts">
	import { page } from '$app/stores';

	const property = $page.data.property;
</script>

<svelte:head>
	<meta property="og:image" content="https://{property.hostname}/og.jpg" />
	<meta property="og:image:type" content="image/jpeg" />
	<meta property="og:image:alt" content="{property.name} - {property.description}" />
	<meta property="og:image:width" content="1200" />
	<meta property="og:image:height" content="630" />
</svelte:head>
